export default __webpack_public_path__ + "node_modules/cakemail-ui-components/lib/dist/glyphs/font/glyphs.svg";